__turbopack_context__.v({
  "appartment": "FormikInputAddressAutocomplete-module-scss-module__p-vXKa__appartment",
  "autocompleteContainer": "FormikInputAddressAutocomplete-module-scss-module__p-vXKa__autocompleteContainer",
  "contactButton": "FormikInputAddressAutocomplete-module-scss-module__p-vXKa__contactButton",
  "dropdownRoot": "FormikInputAddressAutocomplete-module-scss-module__p-vXKa__dropdownRoot",
  "itemOption": "FormikInputAddressAutocomplete-module-scss-module__p-vXKa__itemOption",
  "locationInput": "FormikInputAddressAutocomplete-module-scss-module__p-vXKa__locationInput",
  "postcode": "FormikInputAddressAutocomplete-module-scss-module__p-vXKa__postcode",
  "row": "FormikInputAddressAutocomplete-module-scss-module__p-vXKa__row",
  "state": "FormikInputAddressAutocomplete-module-scss-module__p-vXKa__state",
  "suburb": "FormikInputAddressAutocomplete-module-scss-module__p-vXKa__suburb",
});
